var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833252 4.08325H10.9166M19.1666 4.08325H16.4166",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1666 11.4167H9.08325M0.833252 11.4167H3.58325",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6665 6.83325C15.1853 6.83325 16.4165 5.60204 16.4165 4.08325C16.4165 2.56447 15.1853 1.33325 13.6665 1.33325C12.1477 1.33325 10.9165 2.56447 10.9165 4.08325C10.9165 5.60204 12.1477 6.83325 13.6665 6.83325Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33325 14.1667C4.81447 14.1667 3.58325 12.9355 3.58325 11.4167C3.58325 9.89797 4.81447 8.66675 6.33325 8.66675C7.85204 8.66675 9.08325 9.89797 9.08325 11.4167C9.08325 12.9355 7.85204 14.1667 6.33325 14.1667Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.a324da9f60f982f5fa7fcbc2620bd5c7.svg";
export { ForwardRef as ReactComponent };